import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import "./Faq.css";

const Faq = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Buy & Lease");
  const [faqData, setFaqData] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch FAQ data
  useEffect(() => {
    fetchFaqData();
  }, []);

  const fetchFaqData = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/faq_list`,
        {type: activeTab}

      );

      if (response.data.result) {
        setFaqData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching FAQ data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter FAQs based on active tab
  const filteredFaqs = faqData.filter((faq) => {
    if (activeTab === "Buy & Lease") {
      return faq.type === "Buy & Lease" || faq.type === "Lease & Buy";
    } else if (activeTab === "Return & Refund") {
      return faq.type === "Return & Refund" || faq.type === "Refund & Return";
    }
    return false;
  });

  // Toggle accordion
  const toggleAccordion = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className="faq-container">

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>
      {/* Header */}
      <div className="faq-header">
        
        <h2>FAQ</h2>
      </div>

      {/* Tabs */}
      <div className="faq-tabs">
        <button
          className={`tab-button ${
            activeTab === "Buy & Lease" ? "active" : ""
          }`}
          onClick={() => {
            setActiveTab("Buy & Lease");
            setExpandedIndex(null);
          }}
        >
          Lease & Buy
        </button>
        <button
          className={`tab-button ${
            activeTab === "Return & Refund" ? "active" : ""
          }`}
          onClick={() => {
            setActiveTab("Return & Refund");
            setExpandedIndex(null);
          }}
        >
          Refund & Return
        </button>
      </div>

      {/* FAQ Content */}
      <div className="faq-content">
        {loading ? (
          <div className="loading-state">
            <p>Loading FAQs...</p>
          </div>
        ) : faqData.length > 0 ? (
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${
                  expandedIndex === index ? "expanded" : ""
                }`}
              >
                <div
                  className="faq-question"
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{faq.question || faq.title}</h3>
                  <i
                    className={`las ${
                      expandedIndex === index
                        ? "la-angle-up"
                        : "la-angle-down"
                    }`}
                  ></i>
                </div>
                {expandedIndex === index && (
                  <div className="faq-answer">
                    <p>{faq.answer || faq.description}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="no-faq">
            <p>No FAQs available for this category.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Faq;